<template>
  <div id="app" class="d-flex flex-column"  >
    <router-view/>
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
import axios from 'axios'

export default {
  name: 'app',
  data () {
    return {
      timeout: null,
    }
  },
  mounted() {
    //this.timeout = setInterval(this.makeScreen, 22000);
  },
  destroyed() {
    clearInterval(this.timeout);
  },
  methods: {
    async makeScreen() {
      if(localStorage.getItem('user'))  {
        const canvas = await html2canvas(document.getElementById('bleft'));
        const imgdata = canvas.toDataURL();
        await axios.post('/survey/interviewer/capture', { imgdata });
      }
    },
  }
};
</script>
